import React from "react"
import types from "prop-types"
import { connect } from "react-redux"
import { FacilityAuditTrailContextProvider } from "contexts/FacilityAuditTrailContext"
import Content from "./Content"

const AuditTrailTab = ({ facilityId = "" }) => (
  (
    <FacilityAuditTrailContextProvider facilityId={facilityId}>
      <Content />
    </FacilityAuditTrailContextProvider>
  )
)

AuditTrailTab.propTypes = {
  facilityId: types.number,
}

const mapStateToProps = (state) => (
  {
    facilityId: state.adminFacility.id,
  }
)

export default connect(mapStateToProps, {})(AuditTrailTab)
